export default "__VITE_ASSET__By6$jCia__"